<div class="detail-kpi-row" [attr.data-testid]="testId || null">
    <div *ngFor="let c of cards"
         class="detail-kpi-card"
         [attr.data-testid]="'detail-kpi-' + c.id">
        <div class="detail-kpi-label">
            {{ c.label }}
            <i *ngIf="c.description"
               class="fa fa-info-circle detail-kpi-info"
               [title]="c.description"
               [attr.aria-label]="c.description"></i>
        </div>
        <div class="detail-kpi-value">
            <ng-container *ngIf="c.link as link; else plainValue">
                <a *ngIf="link.routerLink as rl; else clickOnly"
                   [routerLink]="rl"
                   class="detail-kpi-link"
                   [attr.data-testid]="link.testId || null">
                    {{ c.value }}
                    <i class="fa fa-external-link-alt detail-kpi-link-icon"></i>
                </a>
                <ng-template #clickOnly>
                    <a href="javascript:void(0)"
                       class="detail-kpi-link"
                       [attr.data-testid]="link.testId || null"
                       (click)="onLink(c)">
                        {{ c.value }}
                    </a>
                </ng-template>
            </ng-container>
            <ng-template #plainValue>{{ c.value }}</ng-template>
        </div>
        <div *ngIf="c.sub" [class]="subClass(c.subTone)">{{ c.sub }}</div>
    </div>
</div>
